<template>
  <div class="wrapper" v-if="getConfig">
    <sidebar-menu :linkTo="{name:'home'}">
      <ul>
        <router-link tag="li" :to="{name:'home'}" exact>
          <a><i class="fad fa-home"/> Home</a>
        </router-link>
        <li v-if="isTabletOrBigger && getPageVisibility('team-lead')">
          <a href="#dropdown-teamlead" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
            <i
                class="fas fa-user-hard-hat"/> Teamlead</a>
          <ul class="collapse" id="dropdown-teamlead">
            <router-link tag="li"
                         :to="{name: 'users'}" exact>
              <a><i class="far fa-user"/> {{ $t('shopfloor.menu.teamlead.users') }}</a>
            </router-link>
            <router-link tag="li"
                         :to="{name: dockSuggestionRoute}" exact>
              <a><i class="far fa-map-signs"/> {{ $t('shopfloor.menu.teamlead.dockSuggestions') }}</a>
            </router-link>
            <router-link
                v-if="!getAppStatus.disableScanners "
                tag="li"
                :to="{name: orderHandlingRoute}" exact>
              <a><i class="far fa-file-alt"/> {{ $t('shopfloor.menu.teamlead.orderHandling') }}</a>
            </router-link>
            <router-link
                v-if="!getAppStatus.disableScanners "
                tag="li"
                :to="{name: $route.path.indexOf('/unloading') ? 'teamlead-deviations-loading' : 'teamlead-deviations-unloading'}"
                exact>
              <a><i class="far fa-exclamation-circle"/> {{ $t('shopfloor.menu.teamlead.deviations') }}</a>
            </router-link>
            <!--                        <router-link tag="li" :to="{name:'teamlead-unloading-sender-overview'}" exact>-->
            <!--                            <a><i class="fas fa-truck"/>{{$t('shopfloor.menu.teamlead.senderOverview')}}</a>-->
            <!--                        </router-link>-->
            <router-link v-if="!getAppStatus.disableScanners" tag="li" :to="{name:'teamlead-cargo-loading-overview'}"
                         exact>
              <a><i class="fad fa-truck-loading"/> {{ $t('shopfloor.menu.teamlead.cargoOverview') }}</a>
            </router-link>

            <router-link v-if="!getAppStatus.disableScanners" tag="li" v-show="getConfig.unloading.cargo"
                         :to="{name:'teamlead-cargos-unloading'}"
                         exact>
              <a><i class="fad fa-truck-ramp"/>
                {{ $t('shopfloor.menu.teamlead.cargoUnloadingOverview') }}</a>
            </router-link>
          </ul>
        </li>
        <router-link
            v-if="!getAppStatus.disableScanners"
            tag="li"
            :to="{name: 'loodsopname'}" exact>
          <a><i class="far fa-clipboard-check"/> {{ $t('shopfloor.menu.loodsopname') }}</a>
        </router-link>
        <router-link tag="li" :to="{name:'stock-location-change'}" exact v-if="!getAppStatus.disableScanners">
          <a><i class="fal fa-warehouse"/> {{ $t('shopfloor.menu.stockChange') }}</a>
        </router-link>
        <router-link tag="li"
                     :to="{name: 'ScanTraceableProduct'}" exact>
          <a><i class="far fa-map-signs"/> {{ $t('shopfloor.menu.scanTraceableProduct') }}</a>
        </router-link>
        <router-link
            v-if="getPageVisibility('cycle-count')"
            tag="li"
            :to="{name:'cycle-count'}" exact>
          <a><i class="fal fa-abacus"/> {{ $t('shopfloor.menu.cycleCount') }}</a>
        </router-link>


      </ul>

      <div id="loggedIn">
        <ul>


          <li v-if="getPossibleCompanies"
              class="department-info ml-3"
              @click="showDepartmentSelect()"
              style="line-height: 60px"
          >
            <a
                class="desktop-department"
                href="javascript:"
                aria-expanded="false"

                style="line-height: 60px"
            >
              {{ getActiveDepartment }}
            </a>
          </li>
        </ul>
        <p><i class="fas fa-info-circle"></i> V {{ version }} </p>
        <p><i class="fad fa-user"/>{{ getUserName }} <i @click="logout()" style="font-size:20px"
                                                        class="fad fa-sign-out-alt"/></p>
      </div>

    </sidebar-menu>

    <topbar>
      <template slot="left">
        <a href="javascript:;" id="sidebarCollapse" @click="collapsed = !collapsed">
          <i class="fal" :class="[collapsed ? 'fa-bars' : 'fa-align-left']"/>
        </a>
        <router-link v-if="!getAppStatus.disableScanners" class="topbar-link-truck" tag="a" :to="{name:'loading'}">
          <i class="fas fa-truck-loading"/> {{ this.$t('shopfloor.loading') }}
        </router-link>
        <router-link v-if="!getAppStatus.disableScanners" class="topbar-link-truck" tag="a" :to="{name:'unloaded'}">
          <i class="fas fa-truck-ramp"/> {{ this.$t('shopfloor.unloading') }}
        </router-link>
      </template>
    </topbar>

    <div id="m-content">
      <router-view/>
    </div>

    <loading-screen/>
  </div>
  <div v-else>
    <router-view></router-view>
  </div>
  <!--    <vue-progress-bar/>-->
</template>


<script>


// Function to clear the interval when needed


import {mapActions, mapGetters} from 'vuex';
import {LoadingScreen, SidebarMenu, Topbar} from 'motivate-framework-components';
import Vue from 'vue';
import initLogRocket from './init/initLogRocket';
import closeCargo from "@/mixins/closeCargo";
import store from "@/store";
import {openCargo} from "@/mixins/openCargo";
import MotivateCloudApi from "@/init/initCloudApi";
import {auth} from "@/mixins/auth";
import {firebase} from "@/init/firebase";
import isMobile from "@/plugins/isMobile";
import BarcodeScanner from "vue-zebra-barcode-scanner";

export default {
  name: 'App',
  components: {
    SidebarMenu,
    LoadingScreen,
    Topbar
  },
  mixins: [openCargo, auth],
  data() {
    return {
      tokenRefreshInterval: null,
      version: require('./../package.json').version,
      collapsed: false,
      orderHandlingRoute: 'teamlead-order-handling-loading',
      cargoHandlingRoute: 'teamlead-cargo-handling-loading',
      dockSuggestionRoute: 'teamlead-dock-suggestions-loading'
    };
  },
  methods: {
    ...mapActions('users', ['setSelectedCompany']),
    async showDepartmentSelect() {
      let departments = {};

      _.forEach(this.getPossibleCompanies, (dp) => {
        let label = this.getDepartmentLabel(dp.companyId)
        if (label) {
          departments[dp.companyId] = this.getDepartmentLabel(dp.companyId)
        }

      });

      let response = await this.$swal({
        title: this.$root.$t("topbar.selectDepartment"),
        input: "select",
        inputOptions: {
          ...departments,
        },
        inputValue: this.getActiveDepartment
            ? this.getActiveDepartment
            : null,
        inputPlaceholder: 'Selecteer HUB',
        showCancelButton: true,
        inputValidator: (value) => {
          return new Promise((resolve) => {
            resolve();
          });
        },
      });
      if (response.value) {
        const me = this.getMe;
        const currentSelectedCompany = me.customClaims.selectedCompany;

        if (response.value !== currentSelectedCompany) {
          await this.setSelectedCompany(response.value)
        }
        // console.log("ME", me)
        // console.log("response.value", response.value)
        // if (response.value !== this.getMe.activeDepartment) {
        //   // await this.$FBClient.firestore().collection('user-data').doc(this.getMe.uid).set({
        //   //   activeCompany:response.value
        //   // },{merge:true})
        // console.log('updting')
        //   console.log('CLOSE APP  ? Then REINIT')
        //   this.$store.commit("users/selectedWorkflow", null);
        //   this.swalToastSuccess(" Department switched");
        // }
      }
    },
    notAllowedToScan(e) {
      this.$swal.fire({
        html: this.$root.$t('shopfloor.delay', [(e / 1000)]),
        showConfirmButton: false,
        timer: e
      });
    },
    async logout() {
      await closeCargo();
      return this.logOutUser();
    },
    getOrderHandlingRoute() {
      let noLocalStorageOrderHandling = this.$route.path.indexOf('/unloading') > -1 ? 'teamlead-order-handling-unloading' : 'teamlead-order-handling-loading'
      let noLocalStorageDockSuggestions = this.$route.path.indexOf('/unloading') > -1 ? 'teamlead-dock-suggestions-unloading' : 'teamlead-dock-suggestions-loading'

      let localOrderHandling = localStorage.getItem('orderhandling-view') ? (localStorage.getItem('orderhandling-view') === 'loading' ? 'teamlead-order-handling-loading' : 'teamlead-order-handling-unloading') : null
      // Use same local storage so that orderhandling and dock suggestions are in sync
      let localDockSuggestions = localStorage.getItem('orderhandling-view') ? (localStorage.getItem('orderhandling-view') === 'loading' ? 'teamlead-dock-suggestions-loading' : 'teamlead-dock-suggestions-unloading') : null

      this.orderHandlingRoute = localOrderHandling ? localOrderHandling : noLocalStorageOrderHandling;
      this.dockSuggestionRoute = localDockSuggestions ? localDockSuggestions : noLocalStorageDockSuggestions;
    }
  },
  computed: {
    ...mapGetters('users', [
      'getMe',
      'getMeBasic',
      'getUserName',
      'getActiveDepartment',
      'getMyDepartments',
      'getUserNames',
      'getDepartmentLabel'
    ]),
    ...mapGetters('companies', [
      'getCompanies'
    ]),
    ...mapGetters('userData', [
      'getMyFunction', 'getPageVisibility'
    ]),
    ...mapGetters([
      'getLoadingTypes',
      'getConfig'
    ]),
    ...mapGetters('appstatus', [
      'getAppStatus'
    ]),
    loggedInUser() {
      return this.getUserNames.fullName
    },
    isTabletOrBigger() {
      return window.screen.width > 720;
    },
    getPossibleCompanies() {
      return this.getMe && this.getMe.customClaims.possibleCompanies;
    }
  },
  watch: {
    getAppStatus: {
      handler: function (newStatus) {
        if (newStatus.disableScanners && this.$route.name !== 'cycle-count') {
          if (this.$route.name !== 'home')

            this.$router.push({name: 'home'});
        }
      },
      deep: true
    }
  },
  beforeDestroy() {
    clearInterval(this.tokenRefreshInterval);
    localStorage.removeItem('unloading-unloaded-overview')
    if (this.$APP_CONFIG.scanner.type !== 'bluetooth') {
      this.$BluetoothScan.detachFrom(document);
    }
    this.$barcodeScanner.barCodeEventBus.$off('scanDelayed', this.notAllowedToScan);
  },
  async created() {
    const self = this
    if (this.version.toString() !== localStorage.getItem('lastVersion')) {
      console.log("VERSION", this.version.toString(), localStorage.getItem('lastVersion'))
      localStorage.setItem('lastVersion', this.version.toString());
      this.logout();
    }
    firebase.auth().onAuthStateChanged(async function (user) {
      if (user) {
// Alternative approach: Set up periodic token refresh

        setInterval(async () => {
          const user = firebase.auth().currentUser;
          if (user) {
            try {
              // await user.getIdToken(true);
              await user.getIdTokenResult(true)
              console.log('Token refreshed successfully');
            } catch (error) {
              console.error('Periodic token refresh failed:', error);
            }
          }
        }, 50 * 60 * 1000); // Refresh every 50 minutes (tokens expire after 1 hour)


// Call this when your app initializes
        if (self.$route.name === 'login') {
          self.$router.push({name: 'home'})
        }
      } else {
        self.$router.push({name: 'login'})
      }
    });
    if (isMobile.check()) {
      document.addEventListener('deviceready', () => {
        Vue.prototype.$SCANNER_CONFIG = new BarcodeScanner('com.motivate.scanner', null);
      }, false);
    } else {
      Vue.prototype.$SCANNER_CONFIG = new BarcodeScanner('com.motivate.scanner', null);
    }

    const currentUser = await this.getCurrentUser();

    if (currentUser) {
      await this.processUser(currentUser, this)
      await this.reInitFirebase();
    } else {
      // console.log('no uyser found !!!! L302')
      // this.$router.push('/login')
    }
    window.VueGlobalEventBus.$off('userLoggedIn');
    window.VueGlobalEventBus.$on('userLoggedIn', () => {
      let user = this.getMeBasic;
      this.$store.dispatch('initDataForPage', [{module: 'userData', where: ['id', '==', this.getMeBasic.userId]}]);
      // console.log("USER", user)
      initLogRocket(user);
      this.$store.dispatch('initApp');
      this.$barcodeScanner.barCodeEventBus.$on('scanDelayed', this.notAllowedToScan);
    })

    let user = this.getMeBasic;
    if (user.companyId) {

      this.getOrderHandlingRoute();
      // De computed snapt niet dat de localstorage gewijzigd is
      // Dus er is een method gemaakt ipv computed
      // En die moet via een event opnieuw getriggerd worden
      // Anders wordt hij berekent vóórdat de waarde gewijzigd is.
      this.$globalEventBus.$on('orderhandling-view-changed', (params) => {
        this.getOrderHandlingRoute();
      });

      // Close the opened status when the app is hidden
      document.addEventListener("visibilitychange", () => {
        const loadingCargoId = store.getters.getLoadingCargoId;
        if (loadingCargoId) {
          const closed = document.hidden;
          if (closed) {
            // Disable opened
            closeCargo(true);
          } else {
            // Open again
            this.openCargo(loadingCargoId);
          }
        }

      });
    } else {
      //   if (this.$route.name !== 'login')
      //     this.$router.push({name: 'login'})
    }


  },


  // async mounted() {
  //
  //
  //   if (!this.tokenRefreshInterval) {
  //     //
  //     // this.tokenRefreshInterval = setInterval(async () => {
  //     //
  //     //   const currentUser = await this.getCurrentUser();
  //     //   console.log('called refresh', currentUser)
  //     //   if (currentUser) {
  //     //
  //     //
  //     //     firebase.auth().currentUser.getIdToken(true)
  //     //         .then(async (idToken) => {
  //     //           const claims = await this.getClaims(currentUser.email);
  //     //
  //     //
  //     //           // updatedUser.customClaims = claims;
  //     //           // updatedUser.customClaims.companyId = claims.selectedCompany;
  //     //           //
  //     //           // // console.log("updatedUser", updatedUser)
  //     //           store.commit('users/setMe', currentUser);
  //     //
  //     //           Vue.prototype.$CLOUD_API = new MotivateCloudApi(currentUser).getCloudApi();
  //     //
  //     //         })
  //     //         .catch((error) => {
  //     //           console.error("Error refreshing token:", error);
  //     //         });
  //     //   }
  //     // }, 60 * 1000); // Refresh every hour
  //     // // }, 60 * 60 * 1000); // Refresh every hour
  //   }
  // }
};
</script>

<style lang="scss">
@import "./assets/scss/main";
@import "./assets/scss/_customFramework";

</style>

